// テンプレートJSのコード使い回し
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

let  audioPlayer;
let  youtubePlayer;

document.addEventListener('click', function (e) {
    if (e.target.classList.contains('playlist')) {
          audioPlayer = document.querySelector('audio-player');
          const trackList = e.target.parentNode.dataset;
          Object.keys(trackList).forEach(function (key) {
            player.setAttribute(key, trackList[key]);
          });
          const index = e.target.dataset.index
          audioPlayer.setAttribute('index', index);
          if(youtubePlayer){
            youtubePlayer.close()
          }
          fbq('trackCustom', 'PlayButtonClick', { button_name: '音源視聴' });
    }
    if (e.target.classList.contains('youtubelist')) {
        youtubePlayer = document.querySelector('youtube-player');
        const id = e.target.dataset.youtube;
        youtubePlayer.setAttribute('youtube-id', id);
        if(audioPlayer){
          audioPlayer.close()
        }
        fbq('trackCustom', 'PlayButtonClick', { button_name: 'YOUTUBE視聴' });
    } 
});
const searchForm = document.querySelectorAll(".search");
searchForm.forEach(form => {
form.addEventListener('submit', function (e) {
  const input = e.target.querySelector(".search__input");
  let query = input.value;
  query = query.replaceAll('"', "");
  input.value = `"${query}"`
});
});






//preorder obj
function preorder(){}

//barba設定
let isProduct = document.querySelectorAll('[data-template="product"]').length;


barba.init({
    timeout: 5000,
    cacheIgnore: ['/pages/contact/','/cart/'],
    prevent: ({ el,href }) => {
      if(href.includes("/contact") || href.includes("/cart") || href.includes("/pages") || href.includes("/blogs") || href.includes("/account")){
        return true
      }
    },
    transitions: [{
    name: 'default-transition',
    leave() {
       document.querySelector(".content-wrapper").classList.add("on")
    },
    after() {
       window.scrollTo(0,0);
       setTimeout(() => {document.querySelector(".content-wrapper").classList.remove("on")}, 100);

      //メニュー初期化
       const header = document.getElementById('shopify-section-header');
       const mainDetailsToggle = document.querySelector('.menu-drawer-container');
       mainDetailsToggle.classList.remove('menu-opening');
       mainDetailsToggle.querySelectorAll('details').forEach(details => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
        submenu.classList.remove('submenu-open');
      });
      document.querySelector('.header__icon--summary').setAttribute("aria-expanded", "false")
      document.body.classList.remove(`overflow-hidden-tablet`);
      isProduct = document.querySelectorAll('[data-template="product"]').length;
      console.log(isProduct)
      if(isProduct){
        const isNeedReload = (document.getElementById("product-data").dataset.quantity === "0" || document.getElementById("product-data").dataset.preorder === "2") && !document.getElementById("product-data").dataset.issoldout;
        if(isNeedReload){
          location.reload()
        }
      }
      gtag('event', 'page_view', {
        page_title:document.title,
        page_location: location.href,
        send_to: 'G-6YJVVYBF46'
      });
  },
}]
})


//初期化
if(isProduct){
  const isSoldOut = document.getElementById("product-data").dataset.issoldout;
  if(!isSoldOut){
    // ngc_restockInit()
  }
}
let isCart = document.querySelectorAll('#cart').length;
const cartItems = document.querySelector("cart-items");
let isPreorder = []
let isNormal = []

if(isCart){
  fetch('/cart.js')
  .then(response => response.json())
  .then(data => {
      if(data['items'].length){
          data['items'].forEach((item,i) => {
            if(item.properties && item.properties._is_preorder === "予約商品"){
              isPreorder.push(item)
            }else{
              isNormal.push(item)
            }
          })
          if((isPreorder.length && isNormal.length) || isPreorder.length > 1){
            document.querySelector(".cart__checkout-button").disabled = true
            const updates = {};
            if(!isNormal.length){
              isPreorder = isPreorder.slice(0, -1)
            }
            isPreorder.forEach(item => {
              updates[item.id] = 0; // 数量を0にして削除
            });
            setTimeout(function(){
              fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ updates })
              })
              .then((response) => {
              })
              .then(() => {
                alert("カートを自動更新します。カート内に予約商品が2点以上、または通常商品と予約商品が混在しています。システムの都合上、予約は1点づつ注文してください。")
                location.reload(); // カートを更新
              })
              .catch(error => console.error('Error updating cart:', error));
            }, 1000);
          }
      }
  })
  .catch((error) => {
      console.error('Error:', error);
  });
}